module.exports = __webpack_public_path__ + "static/media/Milestones.555bb682.svg";